import { render, staticRenderFns } from "./articleModal.vue?vue&type=template&id=a7eed532&scoped=true"
import script from "./articleModal.vue?vue&type=script&lang=js"
export * from "./articleModal.vue?vue&type=script&lang=js"
import style0 from "./articleModal.vue?vue&type=style&index=0&id=a7eed532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7eed532",
  null
  
)

export default component.exports